<template>
	<div class="section is-fullheight">
		<div class="container is-small">
			<div class="section-body">
				<h2 class="section-subtitle is-black">
					Welcome back!
				</h2>
				<h3 class="section-subtitle is-small-thin">
					Use your login credentials to log in
				</h3>
				<ValidationObserver
					ref="observer"
					class="section-items"
					tag="form"
					@submit.prevent="loginUser"
				>
					<div class="item">
						<div class="section-description">
							Username
						</div>
						<AppInput
							v-model="form.username"
							size="medium"
							:rules="{ required: true }"
							mode="aggressive-touch"
							placeholder="Enter your username"
						/>
					</div>
					<div class="item">
						<div class="section-description">
							Password
						</div>
						<AppInput
							v-model="form.password"
							type="password"
							size="medium"
							:rules="{ required: true }"
							mode="aggressive-touch"
							placeholder="Enter your password"
						/>
					</div>
					<div class="item button">
						<AppButton
							size="full"
							color="primary"
							:disabled="!formIsValid"
						>
							Login
						</AppButton>
					</div>
					<div class="item section-description">
						You're not registered? Please go to
						<router-link
							:to="{ name: 'Landing'}"
							class="description-link"
						>
							Signup.
						</router-link>
					</div>
				</ValidationObserver>
			</div>
		</div>
	</div>
</template>

<script>
import { mapActions } from 'vuex';
import { ValidationObserver } from 'vee-validate';

export default {
	name: 'Login',

	components: {
		ValidationObserver,
	},

	data() {
		return {
			form: {
				username: '',
				password: '',
			},
			formIsValid: false,
		};
	},

	watch: {
		form: {
			async handler() {
				this.formIsValid = await this.$refs.observer.validate({ silent: true });
			},
			deep: true,
		},
	},

	methods: {
		...mapActions('auth', [
			'requestAuthentication',
		]),
		async loginUser() {
			if (this.formIsValid) {
				try {
					await this.requestAuthentication({ username: this.form.username, password: this.form.password });
					this.$router.push({ name: 'Dashboard' });
				} catch (error) {
					this.$notify({
						duration: 6000,
						type: 'error',
						title: 'Login Failed',
						text: 'Failed to authenticate. Please try again',
					});
				}
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.section {
	position: relative;

	.description-link {
		color: $color-primary;
	}

	.section-body {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;

		.section-title,
		.section-subtitle {
			text-align: center;
		}

		.section-description {
			margin-bottom: $gap-1;
			margin-left: $gap-05;
		}

		.section-items {
			display: flex;
			flex-direction: column;

			.item {
				margin-top: $gap-4;

				&.button {
					margin-top: $gap-65;
				}

				&.section-description {
					text-align: center;
				}
			}
		}
	}

	.section-footer {
		position: absolute;
		width: 100%;
		bottom: 0;
	}
}

</style>
